const Roles = {
    Instructor : "Instructor",
    Admin : "Admin",
    SuperVisor:"Supervisor"

}

export default Roles